var map = {
	"./img_avatar_1.png": "7d03",
	"./img_avatar_2.png": "6549",
	"./img_avatar_3.png": "518e",
	"./img_avatar_4.png": "5b2a",
	"./img_avatar_5.png": "6e33",
	"./img_avatar_6.png": "91ce",
	"./img_giveaway_samsung.png": "4e60",
	"./img_life_time_deal.png": "d3a7",
	"./img_life_time_deal_small.png": "99a9",
	"./img_papers.png": "17e5",
	"./img_robot_2.png": "096a",
	"./img_thumbnail_course.png": "f440",
	"./img_thumbnail_default.png": "22a4",
	"./img_thumbnail_modul.png": "5611",
	"./img_thumbnail_note.png": "0831",
	"./img_thumbnail_percubaan.png": "6b0b",
	"./img_thumbnail_spm.png": "b106",
	"./img_thumbnail_topikal.png": "2b63",
	"./img_thumbnail_uasa.png": "9ded",
	"./img_tutor_english.png": "d91f",
	"./img_tutor_english2.png": "cba0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "de3c";